import { get } from 'lodash'

export const CAN_ACCESS = {
  user: {
    create: (item, user) => user.hasPermission('user-management'),
    update: (item, user) => user.hasPermission('user-management'),
    delete: (item, user) =>
      item.id != user.id && user.hasPermission('user-management'),
  },
  workspace: {
    create: (item, user) => user.hasPermission('workspace-management'),
    update: (item, user) => user.hasPermission('workspace-management'),
    delete: (item, user) => user.hasPermission('workspace-management'),
    setting: (item, user) => user.hasPermission('access:admin'),
    publish: (item, user) => user.hasPermission('access:admin'),
  },
  layer: {
    create: (item, user) => user.hasPermission('workspace-management'),
    update: (item, user) => user.hasPermission('workspace-management'),
    delete: (item, user) => user.hasPermission('workspace-management'),
    setting: (item, user) => user.hasPermission('workspace-management'),
  },
  layergroup: {
    create: (item, user) => user.hasPermission('workspace-management'),
    update: (item, user) => user.hasPermission('workspace-management'),
    delete: (item, user) => user.hasPermission('workspace-management'),
    setting: (item, user) => user.hasPermission('workspace-management'),
  },
  style: {
    create: (item, user) => user.hasPermission('style-management'),
    update: (item, user) => user.hasPermission('style-management'),
    delete: (item, user) => user.hasPermission('style-management'),
  },
  basemap: {
    create: (item, user) => user.hasPermission('basemap-management'),
    update: (item, user) => user.hasPermission('basemap-management'),
    delete: (item, user) => user.hasPermission('basemap-management'),
  },
  key: {
    create: (item, user) => user.hasPermission('key-management'),
    update: (item, user) => user.hasPermission('key-management'),
    delete: (item, user) => user.hasPermission('key-management'),
  },
}
export function checkAccess(permission, user, data) {
  let access = get(CAN_ACCESS, permission, () => false)
  return access(data, user)
}
